"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TierSummaryRenewalWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var Constants_1 = require("@falcon/services/dist/Constants");
var services_1 = require("@falcon/services");
var commonFunctions_1 = require("../../../../../commonFunctions");
var TierSummaryRenewalWidget = /** @class */ (function (_super) {
    __extends(TierSummaryRenewalWidget, _super);
    function TierSummaryRenewalWidget(props) {
        return _super.call(this, props) || this;
    }
    TierSummaryRenewalWidget.prototype.render = function () {
        var _this = this;
        var premiumType = this.props.interaction.factors.premiumType;
        var vehicle = this.props.interaction.vehicles[0];
        var tierName = this.getSelectedTierName();
        var tier = (0, commonFunctions_1.getCoverTierWording)(this.props.interaction.coverTier);
        return (React.createElement("div", { className: "renewal-tier-summary-container" },
            React.createElement("p", null,
                "Comprehensive cover, underwritten by LVIC which is an Allianz Group company. All figures include ",
                premiumType === Constants_1.PREMIUM_TYPE_ANNUAL ? 'Insurance Premium Tax' : 'Interest and Insurance Premium Tax',
                "."),
            React.createElement("div", { className: "renewal-tier-summary-widget w-100 d-flex" },
                React.createElement("div", { className: "mb-4 d-flex justify-content-between ".concat(tierName, "-logo-after") },
                    React.createElement("img", { className: "vehicle-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/car-front.svg"), alt: "Vehicle icon" })),
                React.createElement("div", null,
                    React.createElement("h4", null,
                        tier,
                        " Cover"),
                    React.createElement("h4", null, "".concat(vehicle.make, ", ").concat(vehicle.model)),
                    !vehicle.registrationNumber && React.createElement("p", { className: "text-danger" }, "(no registration number)"),
                    vehicle.registrationNumber &&
                        React.createElement("div", { className: "number-plate-preview" }, vehicle.registrationNumber),
                    React.createElement("div", { id: "edit-car-btn", onClick: function () { return _this.navigateToEditCar(); } },
                        React.createElement("button", { type: "button", className: "edit-car-btn btn btn-primary btn-add" }, "Edit this car")),
                    React.createElement("div", { className: "new-quote-wording" }, "or get a new quote to replace it"),
                    React.createElement("div", { id: "replace-car-btn", onClick: function () { return _this.navigateToReplaceCar(); } },
                        React.createElement("button", { type: "button", className: "replace-car-btn btn btn-white mb-0 mt-3" }, "Change this car"))),
                React.createElement("div", { className: "d-flex flex-grow-1 justify-content-end" },
                    React.createElement("img", { src: "/".concat(services_1.resourcesHelper.THEME, "/img/").concat(tierName, ".svg"), alt: "Tier logo", className: "tier-logo" })))));
    };
    TierSummaryRenewalWidget.prototype.getSelectedTierName = function () {
        var tierName = "";
        switch (this.props.interaction.coverTier) {
            case services_1.MotorCoverTier.ALLIANZ_ESSENTIALS:
                tierName = "allianz-essentials-tier";
                break;
            case services_1.MotorCoverTier.ALLIANZ_SILVER:
                tierName = "allianz-silver-tier";
                break;
            case services_1.MotorCoverTier.ALLIANZ:
                tierName = "allianz-tier";
        }
        return tierName;
    };
    TierSummaryRenewalWidget.prototype.navigateToEditCar = function () {
        this.props.engine.navigate("editCarEntryPage", false);
    };
    TierSummaryRenewalWidget.prototype.navigateToReplaceCar = function () {
        this.props.engine.navigate("replaceCarEntryPage", false);
    };
    return TierSummaryRenewalWidget;
}(plugin_journey_1.WidgetBase));
exports.TierSummaryRenewalWidget = TierSummaryRenewalWidget;
//# sourceMappingURL=TierSummaryRenewalWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/renewal/car/TierSummaryRenewalWidget.js
// module id = 3237
// module chunks = 0